export default __webpack_public_path__ + "media/andrew.bd1a43cf.jpg";